import { useState } from "react";

export const instructorDetails = {
	name: "Soham Wani",
	src: "/soham.jpeg",
	tagline: "Web Developer, Product Designer",
};

export function CourseDesc() {
	const [showFullDescription, setShowFullDescription] = useState(false);

	const toggleDescription = () => {
		setShowFullDescription((prev) => !prev);
	};

	return (
		<div className="description-section">
			<h2>Description</h2>

			<div className="description-content">
				<p>
					JavaScript is the most popular programming language in the world. It
					powers the entire modern web and creates millions of high-paying jobs
					globally.
				</p>

				<p>
					If you want to build real websites, interactive applications, or move
					into modern frameworks, JavaScript is unavoidable. And that’s exactly
					why you’re here.
				</p>

				<p>
					JavaScript is a flexible yet extremely powerful language. It can be
					used to build almost anything—but only if you truly understand how it
					works. This course is designed to help you build that strong
					foundation.
				</p>

				{showFullDescription && (
					<>
						<p>
							We don’t skip topics or mark them as unimportant. Instead, we go
							deep into every concept and implement it at an application level,
							so you understand not just what works, but why it works.
						</p>

						<p>
							For every major topic, you’ll work on hands-on assignments and
							coding challenges that push you slightly beyond your comfort zone,
							helping you grow with confidence.
						</p>

						<p>
							This course is built specifically for absolute beginners. You
							won’t find random tutorials stitched together—instead, you’ll
							follow a carefully designed learning path that helps you
							understand JavaScript from the ground up.
						</p>

						<p>
							We also focus heavily on things most courses ignore: debugging,
							problem-solving, and how developers actually think while writing
							code. From day one, you’ll use industry-standard tools to get a
							realistic glimpse of real-world development.
						</p>

						<p>
							Most importantly, we don’t rush into frameworks or libraries. We
							focus on building a rock-solid JavaScript foundation so you can
							confidently move on to modern technologies in the future.
						</p>

						<h3>[01] Why learn from me?</h3>

						<p>
							My name is Soham. I’m a web developer and designer—and a student
							just like you who started learning web development a little
							earlier.
						</p>

						<p>
							I’ve been working with web technologies for around 6 years. I
							learned most of it the hard way, without much guidance. Along the
							way, I’ve worked in the IT industry as a Tech Lead, freelanced
							real-world products, and designed and built multiple applications
							from scratch.
						</p>

						<p>
							Because of this experience, I understand what the industry
							expects, where students usually struggle, and how our generation
							can learn efficiently without feeling overwhelmed.
						</p>

						<p>
							Using this experience, I designed this course as a unique blend of
							deep explanations, theory, hands-on practice, and challenges. The
							goal is simple: to take you from an absolute beginner to a
							confident JavaScript developer in just a few weeks.
						</p>

						<h3>[02] What exactly will you learn?</h3>

						<p>
							You’ll start with JavaScript fundamentals—variables, data types,
							operators, conditions, and loops—and learn how they actually work
							behind the scenes.
						</p>

						<p>
							You’ll then move on to functions, arrays, and objects, followed by
							DOM manipulation and event handling to see how JavaScript works
							inside the browser.
						</p>

						<p>
							You’ll apply your knowledge by building real features like a modal
							window, and finally bring everything together in a complete
							interactive project that strengthens both logic and confidence.
						</p>

						<p>
							For a detailed breakdown, make sure to check out the course
							curriculum.
						</p>

						<h3>[03] Is this course for you?</h3>

						<ul>
							<li>
								You want a true and deep understanding of JavaScript, not just
								memorizing syntax
							</li>
							<li>
								You’ve tried learning JavaScript before but still don’t feel
								confident building real applications
							</li>
							<li>
								You plan to use frameworks or libraries like React, Angular,
								Vue, or Node in the future
							</li>
							<li>
								You’re new to programming and want a great first language to
								start with
							</li>
						</ul>

						<p>
							If any of this sounds like you, start this journey today and
							enroll in the course.
						</p>
					</>
				)}
			</div>

			<button className="show-more-btn" onClick={toggleDescription}>
				{showFullDescription ? "Show less" : "Show more"}
			</button>
		</div>
	);
}

export function CourseFor() {
	return (
		<div className="for-course-section">
			<h2>Who this course is for:</h2>
			<ul>
				<li>
					Absolute beginners who want a strong and clear foundation in
					JavaScript
				</li>
				<li>
					Learners who have tried JavaScript before but still don’t feel
					confident building real applications
				</li>
				<li>
					Students planning to learn frameworks like React, Angular, Vue, or
					Node in the future
				</li>
				<li>
					Anyone looking to start their programming journey with a powerful
					first language
				</li>
			</ul>
		</div>
	);
}

export const courseCiricullum = [
	{
		heading: "JavaScript Fundamentals – Part 1",
		contents: [
			"Setting Up Our Code Editor",
			"Hello World!",
			"A Brief Introduction to JavaScript",
			"Linking a JavaScript File",
			"Values and Variables",
			"Data Types",
			"let, const and var",
			"Basic Operators",
			"Operator Precedence",
			"Strings and Template Literals",
			"Taking Decisions: if / else Statements",
			"Type Conversion and Coercion",
			"Truthy and Falsy Values",
			"Equality Operators: == vs ===",
			"Boolean Logic",
			"Logical Operators",
			"The switch Statement",
			"Statements and Expressions",
			"The Conditional (Ternary) Operator",
			"JavaScript Versions: ES5, ES6+ and ESNext",
		],
	},
	{
		heading: "JavaScript Fundamentals – Part 2",
		contents: [
			"Activating Strict Mode",
			"Functions",
			"Function Declarations vs Expressions",
			"Arrow Functions",
			"Functions Calling Other Functions",
			"Reviewing Functions",
			"Introduction to Arrays",
			"Basic Array Operations (Methods)",
			"Introduction to Objects",
			"Dot vs Bracket Notation",
			"Object Methods",
			"Iteration: The for Loop",
			"Looping Arrays, break and continue",
			"Looping Backwards and Nested Loops",
			"The while Loop",
		],
	},
	{
		heading: "Developer Skills and Environment Setup",
		contents: [
			"Setting Up Prettier and VS Code",
			"Installing Node.js and Setting Up a Dev Environment",
			"Learning How to Code Effectively",
			"How to Think Like a Developer: Problem-Solving Mindset",
			"Using Google, StackOverflow and MDN",
			"Debugging and Fixing Errors",
			"Debugging with the Console and Breakpoints",
		],
	},
	{
		heading: "HTML & CSS Crash Course",
		contents: [
			"Basic HTML Structure and Elements",
			"Attributes, Classes and IDs",
			"Basic Styling with CSS",
			"Introduction to the CSS Box Model",
		],
	},
	{
		heading: "JavaScript in the Browser (DOM & Events)",
		contents: [
			"What Is the DOM and DOM Manipulation",
			"Selecting and Manipulating Elements",
			"Handling Click Events",
			"Manipulating CSS Styles",
			"Refactoring Code Using the DRY Principle",
			"Working With Classes",
			"Handling Keyboard Events (Esc Key)",
			"Implementing the Learned Concepts Using a Modal Window",
		],
	},
	{
		heading: "Final Project – SimplyRoll",
		contents: [
			"Project Setup and Planning",
			"Rolling the Dice",
			"Switching the Active Player",
			"Holding the Current Score",
			"Resetting the Game",
		],
	},
];

export function CourseWhatLearn() {
	return (
		<div className="what-you-learn">
			<h2>What you'll learn</h2>
			<div className="learn-grid">
				<div className="learn-item">
					Build a rock-solid foundation in JavaScript, from variables and data
					types to functions, loops, and objects
				</div>

				<div className="learn-item">
					Write modern, clean JavaScript using let, const, arrow functions, and
					strict mode
				</div>

				<div className="learn-item">
					Understand how JavaScript really works, not just how to copy syntax
				</div>

				<div className="learn-item">
					Think like a real programmer by breaking problems into logical steps
				</div>

				<div className="learn-item">
					Work confidently with arrays and objects to store and manage data
				</div>

				<div className="learn-item">
					Use loops and conditions to build dynamic and flexible programs
				</div>

				<div className="learn-item">
					Learn how JavaScript interacts with the browser and the DOM
				</div>

				<div className="learn-item">
					Build real interactive features like modals and event-driven UI
				</div>

				<div className="learn-item">
					Apply the DRY principle to write clean and maintainable code
				</div>

				<div className="learn-item">
					Use industry-standard tools the same way professional developers do
				</div>

				<div className="learn-item">
					Create a complete interactive game as your final project
				</div>

				<div className="learn-item">
					Gain a strong foundation to easily learn React, Node, and other modern
					frameworks
				</div>
			</div>
		</div>
	);
}

export function CourseIncludes() {
	return (
		<div className="includes-section">
			<h2>This course includes:</h2>
			<p style={{ fontSize: "1.4rem", marginBottom: "1.6rem" }}>
				This course includes our well designed ciricullum, resources and
				challenges curated to cater your needs so you can practice your skills
				as you learn.
			</p>
			<div className="includes-grid">
				<div className="includes-item">
					<span>📹</span> One to One teaching sessions
				</div>
				<div className="includes-item">
					<span>💻</span> Coding exercises
				</div>
				<div className="includes-item">
					<span>📄</span> Assignments
				</div>
				<div className="includes-item">
					<span>💾</span> Downloadable resources
				</div>
				<div className="includes-item">
					<span>🏆</span> Certificate of completion
				</div>
			</div>
		</div>
	);
}

export function CourseReq() {
	return (
		<div className="requirements-section">
			<h2>Requirements</h2>
			<ul>
				<li>
					No coding experience is necessary to take this course! I take you from
					beginner to expert!
				</li>
				<li>
					Any computer and OS will work — Windows, macOS or Linux. We will set
					up your text editor the course.
				</li>
				<li>
					You don’t need to buy any software — we will use the best free code
					editor in the world{" "}
				</li>
			</ul>
		</div>
	);
}

export const courseHeading = "JavaScript From Zero to Confident Developer";

export const courseSubtitle =
	"Build a rock-solid JavaScript foundation through hands-on projects, real-world logic, and the mindset of a professional programmer.";
